import { useTranslation } from 'react-i18next'

export function HelloWidget(props: { name: string }) {
  const globalTranslation = useTranslation('home', { keyPrefix: 'Global' })

  return (
    <div className='max-w-[100%]'>
      <div className='hello-text'>{globalTranslation.t('Hello')},</div>
      <div className='hello-name-text line-clamp-3 max-w-full pt-1 lg:overflow-hidden lg:text-ellipsis lg:whitespace-nowrap'>
        {props.name}
      </div>
    </div>
  )
}
